import DeadMemberDetailsActionTypes from './dead-member-report.type';

/** ***************** GET DEAD MEMBER REPORT DETAILS START *********************** */
export const getDeadMemberDetailsDetailsStart = (getData: any) => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_START,
	payload: getData,
});

export const getDeadMemberDetailsDetailsSuccess = (successData: any) => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_SUCCESS,
	payload: successData,
});

export const getDeadMemberDetailsDetailsFailure = (failureData: any) => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_FAILURE,
	payload: failureData,
});

export const getDeadMemberDetailsDetailsResponseResetStart = () => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_RESPONSE_RESET,
});

export const getDeadMemberDetailsDetailsResponseChanged = () => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DEAD MEMBER REPORT DETAILS END *********************** */

/** ***************** GET DEAD MEMBER EXPORT REPORT DETAILS START *********************** */
export const getDeadMemberDetailsExportStart = (getData: any) => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_START,
	payload: getData,
});

export const getDeadMemberDetailsExportSuccess = (successData: any) => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_SUCCESS,
	payload: successData,
});

export const getDeadMemberDetailsExportFailure = (failureData: any) => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_FAILURE,
	payload: failureData,
});

export const getDeadMemberDetailsExportResponseResetStart = () => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_RESPONSE_RESET,
});

export const getDeadMemberDetailsExportResponseChanged = () => ({
	type: DeadMemberDetailsActionTypes.GET_DEAD_MEMBER_DETAILS_EXPORT_RESPONSE_CHANGED,
});
/** ***************** GET DEAD MEMBER EXPORT REPORT DETAILS END *********************** */
